import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import WelcomeScreen from '../components/unsubscribe-mail/welcome-screen';
import { getImageFromS3 } from '../imageService';
import EmailApproveScreen from '../components/unsubscribe-mail/email-approve-screen';
import AppreciationScreen from '../components/unsubscribe-mail/appreciation-screen';
import SuccessScreen from '../components/unsubscribe-mail/success-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import useScreenHistory from '../hooks/useScreenHistory';

const UnsubscribeMail = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 0
  });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('Unsubscribe-Mail');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', 'Marlboro_Titanium');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 0: {
        return (
          <WelcomeScreen
            setScreenNumber={cb}
            approveButtonClick={() => setScreenNumber(1)}
            cancelButtonClick={() => setScreenNumber(2)}
            backgroundImage={`url("${getImageFromS3(
              'images/unsubscribe-mail/violet-background.png'
            )}")`}
          />
        );
      }
      case 1: {
        return (
          <EmailApproveScreen
            setScreenNumber={cb}
            handleNextButtonClick={() => setScreenNumber(3)}
            backgroundImage={`url("${getImageFromS3(
              'images/unsubscribe-mail/violet-background.png'
            )}")`}
          />
        );
      }
      case 2: {
        return (
          <AppreciationScreen
            setScreenNumber={cb}
            backgroundImage={`url("${getImageFromS3(
              'images/unsubscribe-mail/violet-background.png'
            )}")`}
          />
        );
      }
      case 3: {
        return (
          <SuccessScreen
            setScreenNumber={cb}
            backgroundImage={`url("${getImageFromS3(
              'images/unsubscribe-mail/violet-background.png'
            )}")`}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <div className={styles.pageContainer} id="unsubscribe">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default UnsubscribeMail;
